import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=b9f66f2e&scoped=true&"
import script from "./form-item.vue?vue&type=script&lang=js&"
export * from "./form-item.vue?vue&type=script&lang=js&"
import style0 from "./form-item.vue?vue&type=style&index=0&id=b9f66f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f66f2e",
  null
  
)

export default component.exports